import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import {
  selectPrefix,
  selectWidth,
  selectreportFromDate,
  selectreportToDate,
  setreportsFromDate,
  setreportsTodate,
} from "../../utility/Redux/profile";
import { FromToDate } from "../../utility/component/fromToDate";
import { GetPurchaseSummary } from "./func";
import { selectToken } from "../../utility/Redux/security";
import AccountMasterHelp from "../../help/listAccountMasterHelp";
import { PurchaseSummaryColumns } from "./columns";
import Footer from "./footer";
import { useReactToPrint } from "react-to-print";
import GeniusTableReports from "../../utility/component/geniusComponents/geniusTableData";
import PrintWithFooter from "../../utility/component/datagrid/printReportWithFooter";
import { PrintPurchaseSummaryColumns } from "./printColumns";
import IsLocalData from "../../utility/component/isLocalData";
import FromToDateMobile from "../../utility/component/fromToDateMobile";
import OrderReceiptModal from "../../CreateOrder/printOrderBill";
import { LoadBill } from "../../CreateOrder/function";
import { setSpinnerLoading } from "../../utility/Redux/modal";
import { ItemMasterHelp } from "../../help";
import CustomerMasterHelp from "../../help/customermasterHelp";
import NewPrintReport from "../../utility/component/datagrid/newPrintReport";
import { FormatNumber2 } from "../../utility/functions/formatNumber";
import NewPrintReportByGrouping from "../../utility/component/datagrid/newPrintByGrouping";

const ItemWiseOrder = () => {
  const prefix = useSelector(selectPrefix);
  const [purchaseList, setPurchaseList] = useState([]);
  const fromDate = useSelector(selectreportFromDate);
  const ToDate = useSelector(selectreportToDate);
  const width = useSelector(selectWidth);
  const [itemData, setItemData] = useState({
    ITEMNAME: "",
    ICODE: "",
  });

  const [getCustomerData, setCustomerData] = useState({
    CUSTOMER_NAME: "",
    CUSTOMER_MOBILE: "",
  });
  const [viewBillStatus, setViewBillStatus] = useState(false);
  const [printData, setPrintData] = useState([]);

  const columns = PurchaseSummaryColumns(width);
  const printColumns = PrintPurchaseSummaryColumns(width);
  const [customerHelpStatus, setCustomerHelpStatus] = useState(false);
  const [itemHelpStatus, setItemHelpStatus] = useState(false);
  const [partyHelpStatus, setPartyHelpStatus] = useState(false);
  const printRef = useRef(null);
  const dispatch = useDispatch();
  const token = useSelector(selectToken);
  const okButton = () => {
    GetPurchaseSummary(
      {
        table_prefix: prefix,
        FDATE: moment(fromDate).format("YYYY-MM-DD"),
        TDATE: moment(ToDate).format("YYYY-MM-DD"),
        CUSTOMER_MOBILE: getCustomerData.CUSTOMER_MOBILE
          ? getCustomerData.CUSTOMER_MOBILE
          : "",
        ICODE: itemData.ICODE ? itemData.ICODE : "",
      },
      token,
      dispatch,
      setPurchaseList
    );
  };
  const handlePrint = useReactToPrint({
    content: () => printRef.current,
  });
  const [status, setStatus] = useState("Pending");
  useEffect(() => {
    const callback = (details, data) => {
      setCustomerData(details[0]);
      setPurchaseList(data);
      dispatch(setreportsFromDate(details[0].FDATE));
      dispatch(setreportsTodate(details[0].TDATE));
    };
    const elseFunc = () => {};
    IsLocalData("item_wise_order", callback, elseFunc);
  }, []);

  return (
    <div className=" bg-white flex flex-col h-full w-full overflow-y-scroll">
      <div className=" flex flex-col h-full p-3  w-full">
        <div>
          {window.innerWidth <= 1000 ? (
            <>
              <FromToDateMobile
                submit={okButton}
                customerData={{
                  CUSTOMER_NAME: getCustomerData?.CUSTOMER_NAME,
                  CUSTOMER_MOBILE: getCustomerData?.CUSTOMER_MOBILE,
                }}
                itemData={{
                  ICODE: itemData.ICODE,
                  ITEMNAME: itemData.ITEMNAME,
                }}
                onItemClick={() => {
                  setItemHelpStatus(true);
                }}
                onCustomerSearchClick={(e) => setCustomerHelpStatus(true)}
                customerClear={() => {
                  setCustomerData((e) => {
                    return {
                      CUSTOMER_NAME: "",
                      CUSTOMER_MOBILE: "",
                    };
                  });
                  setPurchaseList([]);
                }}
                onPrintClick={handlePrint}
              />
            </>
          ) : (
            <FromToDate
              hideReset
              submit={okButton}
              customerData={{
                CUSTOMER_NAME: getCustomerData?.CUSTOMER_NAME,
                CUSTOMER_MOBILE: getCustomerData?.CUSTOMER_MOBILE,
              }}
              onPrintClick={handlePrint}
              itemData={{
                ICODE: itemData.ICODE,
                ITEMNAME: itemData.ITEMNAME,
              }}
              onItemClick={() => {
                setItemHelpStatus(true);
              }}
              onCustomerSearchClick={(e) => setCustomerHelpStatus(true)}
              customerClear={() => {
                setCustomerData((e) => {
                  return {
                    CUSTOMER_NAME: "",
                    CUSTOMER_MOBILE: "",
                  };
                });
                setPurchaseList([]);
              }}
            />
          )}
        </div>

        <div className="flex text-sm border p-2 rounded-sm w-fit mt-2 items-center space-x-2">
          <div className="font-medium">Filter:</div>
          <select
            value={status}
            onChange={(e) => setStatus(e.target.value)}
            className="border rounded px-2 py-1 focus:outline-none focus:ring focus:ring-orange-400"
          >
            <option value="Pending">Pending</option>
            <option value="Rejected">Rejected</option>
            <option value="Delivered">Delivered</option>
            <option value="All">All</option>
          </select>
        </div>

        <div
          style={{ height: `calc(100% - 0px)`, width: "100%", marginTop: 6 }}
          className=" mb-2 "
        >
          {purchaseList[0] ? (
            <GeniusTableReports
              columns={columns}
              data={purchaseList.filter((p) => {
                if (status === "Pending") {
                  return (
                    p.BILL_STATUS === "Pending" || p.BILL_STATUS === "Order"
                  );
                } else {
                  if (status === "Rejected") {
                    return p.BILL_STATUS === "Rejected";
                  } else {
                    if (status === "All") {
                      return true;
                    } else {
                      if (status === "Delivered") {
                        return p.BILL_STATUS === "Settled";
                      }
                    }
                  }
                }
              })}
              onRowDoubleClick={(p) => {
                dispatch(setSpinnerLoading("Loading"));
                LoadBill(
                  prefix,
                  token,
                  dispatch,
                  p.original.ORDER_NO,
                  () => {},
                  () => {},
                  () => {},
                  () => {},
                  "",
                  false,
                  setPrintData
                )
                  .then((l) => {
                    setPrintData(l);
                    setViewBillStatus(true);
                  })
                  .finally(() => {
                    dispatch(setSpinnerLoading(false));
                  });
              }}
              footer={<Footer columns={columns} rows={purchaseList} />}
            />
          ) : (
            <div className="h-full flex justify-center items-center text-sm text-gray-400 border mt-3 rounded-sm">
              No Records Found
            </div>
          )}
        </div>

        <div>
          <div
            style={{
              display: "none",
            }}
          >
            <div ref={printRef}>
              <NewPrintReportByGrouping
                details={[
                  {
                    name: "From Date",
                    value: moment(fromDate).format("DD/MM/YYYY"),
                  },
                  {
                    name: "To Date",
                    value: moment(ToDate).format("DD/MM/YYYY"),
                  },
                  {
                    name: "Customer",
                    value: getCustomerData.CUSTOMER_NAME,
                  },
                ]}
                title={"Item Wise Orders"}
                data={purchaseList.filter((p) => {
                  if (status === "Pending") {
                    return (
                      p.BILL_STATUS === "Pending" || p.BILL_STATUS === "Order"
                    );
                  } else {
                    if (status === "Rejected") {
                      return p.BILL_STATUS === "Rejected";
                    } else {
                      if (status === "All") {
                        return true;
                      } else {
                        if (status === "Delivered") {
                          return p.BILL_STATUS === "Settled";
                        }
                      }
                    }
                  }
                })}
                columns={printColumns}
                groupBy={"CUSTOMER_MOBILE"}
                footer={
                  <Footer
                    isFeilds={
                      <div className="flex justify-end text-sm mt-2">
                        <div>
                          <div className="flex ">
                            <div className="font-semibold w-[160px] text-right ">
                              Total Items :
                            </div>
                            <div className="ml-2 flex flex-1 justify-end ">
                              {purchaseList.reduce(
                                (acc, row) => acc + Number(row.QNTY),
                                0
                              )}
                            </div>
                          </div>

                          <div className="flex">
                            <div className="font-semibold w-[160px]   text-right">
                              Total Amount :
                            </div>
                            <div className="ml-2">
                              {FormatNumber2(
                                purchaseList.reduce(
                                  (acc, row) => acc + Number(row.AMOUNT),
                                  0
                                )
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    }
                    columns={printColumns}
                    rows={purchaseList}
                  />
                }
              />
            </div>
          </div>
        </div>
      </div>

      <ItemMasterHelp
        status={itemHelpStatus}
        onClose={() => {
          setItemHelpStatus(false);
        }}
        onRowClick={(p) => {
          setItemHelpStatus(false);
          setItemData(p.row);
        }}
      />
      <CustomerMasterHelp
        onRowClick={(p) => {
          setCustomerHelpStatus(false);
          setCustomerData(p.row);
        }}
        status={customerHelpStatus}
        onClose={() => {
          setCustomerHelpStatus(false);
        }}
      />
    </div>
  );
};

export default ItemWiseOrder;
